import gql from 'graphql-tag';

export const ArticleBodyEntriesFragment = gql`
  # Fragment to query for linked embedded block entries
  # Related docs:
  #   https://www.contentful.com/developers/docs/concepts/links/
  #   https://www.contentful.com/developers/docs/references/graphql/#/reference/schema-generation/rich-text
  #   https://graphql.org/learn/queries/#fragments
  #   https://graphql.org/learn/schema/#union-types
  fragment InArticleCtaFragment on InArticleCta {
    internalName
    headline
    buttonText
    buttonUrl
    subhead
    isSubheadBold
    image {
      url
      description
    }
    layout
  }
  fragment ArticleBodyEntriesFragment on ArticleBodyEntries {
    block {
      __typename
      sys {
        id
      }
      ... on Table {
        table
      }
      ... on ZapTemplateComponent {
        zapTemplateIDs
      }
      ... on CalloutTopic {
        body {
          json
        }
      }
      ... on PullQuoteTopic {
        quote
        quoteByLine
      }
      ... on RichImageAsset {
        maxWidth
        describedImage
        image {
          url
          title
        }
        describedImage
        caption {
          json
        }
      }
      ... on SectionAnchorAssembly {
        htmlId
        internalName
      }
      ... on EbookAsset {
        internalName
      }
      ... on VideoAsset {
        videoId
        videoProvider {
          name
        }
        caption {
          json
        }
      }
      ... on InArticleCtaContainer {
        fallbackCta {
          ...InArticleCtaFragment
        }
        variantsCtaCollection {
          items {
            persona {
              slug
            }
            inArticleCta {
              ...InArticleCtaFragment
            }
          }
        }
      }
    }
    inline {
      __typename
      sys {
        id
      }
      ... on CustomAhrefAssembly {
        destinationUrl
        displayText
        refTags
      }
    }
  }
`;
